import { Body, Caption, cn } from '@vrzl/ui';
import { Bot } from 'lucide-react';

import type { ChatEntry } from '../api/types';

import { ChatSources } from './chatSources';

type ChatMessageProps = {
  entry: ChatEntry;
  documents: { id: string; name: string; sourceFileName: string | null }[];
  eventId: string;
  hideSources?: boolean;
};

export function ChatMessage({ entry, documents, eventId, hideSources }: ChatMessageProps) {
  const isUser = entry.role === 'user';

  return (
    <div className={cn('flex gap-2', isUser ? 'justify-end' : 'justify-start')}>
      {!isUser && (
        <div className="flex size-8 shrink-0 items-center justify-center rounded-full bg-muted">
          <Bot className="size-4 text-muted-foreground" />
        </div>
      )}
      <div className="max-w-[80%]">
        <div
          className={cn(
            'rounded-lg border px-3 py-2',
            isUser ? 'border-primary-600 bg-primary-600' : 'border-border bg-card',
          )}
        >
          <Body tone={isUser ? 'on-primary' : 'default'} className="whitespace-pre-wrap">
            {entry.content}
          </Body>
        </div>
        {!isUser && !hideSources && (
          <ChatSources sources={entry.sources} documents={documents} eventId={eventId} />
        )}
        {entry.timestamp && <Caption className="mt-1">{entry.timestamp}</Caption>}
      </div>
    </div>
  );
}
